export function affiliatedBusinessDisclosureCB2026() {
return [   // Release 2026-01-13 10:22:11
 {
   page: 0,
    name: "Logo",
    type: "logo",
    top: 28.673,
    left: 53,
    width: 240,
    height: 36,
 }, 
{
   page: 0,
   name: "Client Names Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 93.401,
   left: 107.063,
   width: 355.320,
   height: 13.926
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 166.698,
   left: 107.063,
   width: 76.482,
   height: 12.989
}
,
{
   page: 2,
   name: "Date Broker provided", 
   fontSize: 9,
   type: "date",
   top: 281.564,
   left: 227.367,
   width: 72.219,
   height: 13.091
}
,
{
   page: 2,
   name: "Signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 357.72,
   left: 65.16,
   width: 250.20,
   height: 12.371
}
,
{
   page: 2,
   name: "Date Signature Broker", 
   fontSize: 9,
   type: "date",
   top: 357.72,
   left: 381.72,
   width: 130.08,
   height: 12.371
}
,
{
   page: 2,
   name: "Checkbox Seller declined to sign disclosure", 
   isText: false,
   type: "checkbox",
   top: 325.965,
   left: 43.2002,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Buyer declined to sign disclosure", 
   isText: false,
   type: "checkbox",
   top: 327.274,
   left: 389.456,
   width: 10.080,
   height: 10.080
}
] }
